import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { PaginatedResults } from '@app/interfaces/paginated-results';
import { Observable } from 'rxjs';
import { CreateOrderReqDto } from '../interfaces/create-order.req.dto';
import { Order } from '../interfaces/order';
import { OrderDetails } from '../interfaces/order-details';
import { PaymentDetails } from '../interfaces/payment-details';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  constructor(private apiService: ApiService) {}

  createOrder(
    imageDetailIds: number[],
    data: CreateOrderReqDto,
  ): Observable<PaymentDetails> {
    return this.apiService.post<PaymentDetails>('image/order', {
      ...data,
      image_detail: imageDetailIds,
    });
  }

  loadOrderDetails(imageDetailIds: number[]): Observable<OrderDetails> {
    return this.apiService.post<OrderDetails>('image/cart', {
      image_details_ids: imageDetailIds,
    });
  }

  getDownloads(page: number = 1): Observable<PaginatedResults<Order>> {
    const data: any = {};
    if (page > 1) {
      data.page = page;
    }
    return this.apiService.getPaginatedResults<Order>('profile/orders', data);
  }
}
